import React from 'react'
// components
import Risk from 'components/PageComponents/Risks/Register/components/RiskView/components/RisksContainer/components/RiskContainer/components/Risk'
// layers
import RiskViewProvider, { NRiskContext } from 'containers/Risks/RiskView/Risk/layers'
import RiskViewRelatedRiskContainer from 'containers/Risks/RiskView/RelatedForm'
// hooks
import { useRelatedFields } from 'hooks/risks/useRelatedFields'
// types
import { IInlineRelatedForm } from 'types/graphql'
// utils
import { v4 as uuid } from 'uuid'

interface Props {
  isScheduled: boolean
  initialValues: Record<string, any>
}

const RiskViewRiskContainer: React.FC<NRiskContext.IProps & Props> = ({ initialValues, risk, ...props }) => {
  const { relatedFormsIds } = useRelatedFields()

  const inlineRelatedForms: IInlineRelatedForm[] = React.useMemo(
    () =>
      relatedFormsIds.map((id) => {
        const inlineForm = risk.inlineRelatedForms?.find((item) => item.riskTemplateId === id)

        return {
          id: inlineForm?.id || uuid(),
          fieldValueMap: inlineForm?.fieldValueMap || [],
          riskTemplateId: inlineForm?.riskTemplateId || id
        }
      }),
    [relatedFormsIds, risk]
  )

  return (
    <RiskViewProvider risk={risk} {...props}>
      <Risk form={props.form} initialValues={initialValues} />
      {inlineRelatedForms?.map((item) => (
        <RiskViewRelatedRiskContainer
          key={item.id}
          risk={item}
          parentRiskId={risk.id}
          isScheduled={props.isScheduled}
          riskTemplateId={item.riskTemplateId}
        />
      ))}
    </RiskViewProvider>
  )
}

export default RiskViewRiskContainer
